import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const lotteryTypeInputStyles = {
    wrap: css``,
    pickBet: css``,
    pickRow: css`
        display: flex;
        align-items: center;
        padding: 8px 0;
    `,
    pickLeft: css`
        display: flex;
        align-items: center;
        flex: 1;

        p {
            flex: 0 0 60px;
        }
    `,
    pickNum: css`
        display: flex;
        gap: 8px;
    `,
    numPickItem: css`
        width: 40px;
        height: 40px;
        border-radius: 36px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-weight: 600;
        text-align: center;
        line-height: 35px;
        margin-right: 10px;
        font-size: 22px;
        vertical-align: middle;
        color: ${colors.primary};
        border: 2px solid ${colors.primary};

        &.active {
            background: ${'#e76541'};
            border-color: ${'#e76541'};
            color: ${colors.white};
        }
        &:hover {
            border-color: ${'#e76541'};
        }
    `,
    pickRight: css`
        display: flex;
        gap: 6px;
    `,
    btnPickQick: css`
        font-size: 14px;
        padding: 4px 0;
        min-width: 52px;
        /* border: 1px solid #bce1e1; */
        border-radius: 6px;
        cursor: pointer;
        box-shadow: 1px 1px 0px rgba(51, 51, 51, 0.1490196078);
        background-color: #fff;
        border-radius: 5px;
        padding: 0 10px;
        height: 35px;
        min-width: 50px;
        text-align: center;
        line-height: 37px;
        margin-left: 10px;
        font-size: 16px;
        &.active {
            background: ${'#df6b02'};
        }
    `,
};
export default lotteryTypeInputStyles;
